import { apiRequest } from './client'
import type { Reminder, ReminderRepeat, ReminderTargetType } from './types'

export const remindersApi = {
  list: () => apiRequest<{ data: Reminder[] }>('/reminders'),

  create: (input: {
    targetType: ReminderTargetType
    targetId?: string
    roleId?: string
    ownerUserId?: string
    message: string
    dueAt: string
    repeat?: ReminderRepeat
    notifyInPanel?: boolean
    notifyDiscord?: boolean
  }) => apiRequest<{ data: Reminder }>('/reminders', { method: 'POST', body: input }),

  update: (id: string, input: Partial<{ message: string; dueAt: string; repeat: ReminderRepeat; notifyInPanel: boolean; notifyDiscord: boolean }>) =>
    apiRequest<{ data: Reminder }>(`/reminders/${id}`, { method: 'PATCH', body: input }),

  remove: (id: string) => apiRequest<{ data: { success: boolean } }>(`/reminders/${id}`, { method: 'DELETE' }),
}
